export const REQUIRED_ERROR = "requiredError";
export const MIN_LENGTH_ERROR = "minLengthError";
export const MIN_MAX_LENGTH_ERROR = "minMaxLengthError";
export const MAX_LENGTH_ERROR = "maxLengthError";

export const ERRORS = [REQUIRED_ERROR, MIN_LENGTH_ERROR, MIN_MAX_LENGTH_ERROR, MAX_LENGTH_ERROR] as const;
export const PREFIXED_ERRORS = [MIN_LENGTH_ERROR, MIN_MAX_LENGTH_ERROR, MAX_LENGTH_ERROR];

export type RuleError = typeof ERRORS[number];
